import { Box } from '@mui/material';

const CircleActive = ({ color, size }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: color,
      }}
    />
  );
};

export default CircleActive;
